import React, { useMemo } from "react";
import classnames from "classnames";
import { SensorDataRestoringRequest } from "@shared/models";
import { QUERY_EXECUTION_STATUS_ATHENA } from "@shared/constants";
import { ReactComponent as ImportIcon } from "@assets/images/icons/general/import.svg";
import { ReactComponent as RestoreIcon } from "@assets/images/icons/general/restore.svg";

import "./index.scss";

export interface SensorDataRestoringRequestStatusProps {
  item: SensorDataRestoringRequest;
  onDownloadClick: (item: SensorDataRestoringRequest) => void;
  onRestoreClick: (item: SensorDataRestoringRequest) => void;
}

export default function SensorDataRestoringRequestStatus(props: SensorDataRestoringRequestStatusProps) {
  const { item, onDownloadClick, onRestoreClick } = props;

  const status = useMemo(() => item.athena_query_execution_status, [item]);

  const canMakeAction = useMemo(() => [QUERY_EXECUTION_STATUS_ATHENA.SUCCEEDED].find((s) => s === status), [status]);
  const canRestore = useMemo(
    () => canMakeAction && !item.is_imported_to_mongodb && !item.is_importing_to_mongodb,
    [canMakeAction, item],
  );

  const restoreText = useMemo(() => {
    if (!item.is_imported_to_mongodb && item.is_importing_to_mongodb) {
      return "Restoring";
    }

    return item.is_imported_to_mongodb ? "Restored" : "Restore";
  }, [item]);

  return (
    <div className="sensor-data-restoring-request-actions">
      <div className={classnames("download-action", { disabled: !canMakeAction })}>
        <ImportIcon /> <span onClick={canMakeAction ? () => onDownloadClick(item) : undefined}>Download</span>
      </div>
      <div className={classnames("restore-action", { disabled: !canRestore, restoring: item.is_importing_to_mongodb })}>
        <RestoreIcon /> <span onClick={canRestore ? () => onRestoreClick(item) : undefined}>{restoreText}</span>
      </div>
    </div>
  );
}
